import BossModel from "@/models/BossModel";
import PackageDaytodayImage from "./Image/Image";

export default class Daytoday extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'package/daytoday';

    /**
     *
     * @type {string}
     */
    static entity = 'packageDaytodays';

    static fields() {
		return {
			id:this.number(null).nullable(),
			day_number: this.attr(null),
			title: this.attr(null),
			subtitle: this.attr(null),
			sort_order:this.number(null).nullable(),
			text: this.attr(null),
			package_id: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            images: this.hasMany(PackageDaytodayImage, 'package_daytoday_id'),
		}
	}

    /**
     *
     * @returns {*}
     */
    static loadAll() {
        return this.api()
            .where('is_active', true)
            .get(true);
    }

    /**
     *
     * @returns {*}
     */
    PackageDaytodayImages(){
        return this.getRelated('images');
    }
}
